import React from 'react';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/system';

interface IProps {
  name: React.ReactNode | string;
  onClick?: any;
  style?: any;
  className?: string;
}

const CustomChipRoot = styled('span')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  '& > *': {
    margin: theme.spacing(0),
  },
}));

function CustomChip({ name, onClick, style, className }: IProps) {
  return (
    <CustomChipRoot style={style} className={className}>
      <Chip
        label={name}
        onClick={onClick}
        style={{ fontFamily: 'Poppins, sans-serif' }}
        variant="outlined"
      />
    </CustomChipRoot>
  );
}

export default CustomChip;
